// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsCardGetBody = {
  poolId: string;
  eventId: string;
};

export type typeStripsCardGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    card: {
      stripCardId: string;
      eventId: string;
      isCanceled: boolean;
      canceledAt?: string | null;
      cancelReason?: string | null;
      stripCount: number;
      maxStripCount: number;
      canAddStrip: boolean;
    };
    game: {
      eventId: string;
      label: string;
      kickoffAt: string;
      status:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed";
      statusLabel: string;
      homeTeamId: string;
      awayTeamId: string;
      homeTeamName: string;
      awayTeamName: string;
      homeTeamAbbreviation: string;
      awayTeamAbbreviation: string;
      homeScore?: number | null;
      awayScore?: number | null;
      isCustom: boolean;
    };
    strips: {
      stripNumber: number;
      label: string;
      state: "open" | "locked";
      lockedAt?: string | null;
      filledCount: number;
      isFull: boolean;
      mySpotCount: number;
      canClaim: boolean;
      claimBlockedReason?:
        "stripLocked" | "limitReached" | "gameCanceled" | null;
      canCopyUsers: boolean;
      rows: {
        row: number;
        rowLabel: string;
        digit?: number | null;
        userId?: string | null;
        displayName?: string | null;
        initials?: string | null;
        avatarUrl?: string | null;
        isMine: boolean;
        winners: { stripWinnerId: string; wonAt: string; note: string }[];
      }[];
    }[];
    viewer: {
      userId: string;
      canManage: boolean;
      maxSpotsPerMember?: number | null;
    };
    refreshAfterSeconds: number;
  };
};

export type typeStripsCardGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsCardGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsCardGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsCardGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "eventId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsCardGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsCardGetBody);
  }

  return async function postStripsCardGet(
    payload: typeStripsCardGetBody,
  ): Promise<typeStripsCardGetOutput200 | typeStripsCardGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsCardGet" failed before calling the network. #b2ef8872547e`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#b2ef8872547e" },
        },
        data: null,
      } as typeStripsCardGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/card-get`,
      httpMethod: "POST",
      options,
    })) as typeStripsCardGetOutput200 | typeStripsCardGetOutput400;
  };
}
